import { Component, computed, inject, signal } from '@angular/core';
import { ActivatedRoute, Data, RouterModule } from '@angular/router';

import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { PlanktonTaxon } from '@models';
import { WoRMSURLPipe } from '@pipes';
import { TitleService } from '@services';
import { PlanktonPropertyListComponent } from '../../propertylist/propertylist.component';

@Component({
  selector: 'app-plankton-taxon-item',
  templateUrl: './item.component.html',
  styleUrls: ['./item.component.scss'],
  imports: [
    MatButtonModule,
    MatIconModule,
    MatMenuModule,
    PlanktonPropertyListComponent,
    RouterModule,
    WoRMSURLPipe
],
})
export class PlanktonTaxonItemComponent {
  titleService = inject(TitleService);

  route = inject(ActivatedRoute);

  taxon = signal<PlanktonTaxon>(this.route.snapshot.data['taxon']);
  title = computed(() => this.taxon().scientificName);

  constructor() {
    this.route.data.subscribe((data: Data) => {
      this.taxon.set(data['taxon']);
      this.titleService.setTitle(this.title());
    });
  }
}
